import { minimatch } from 'minimatch';

export const matchesAnyPattern = (toMatch: string, patterns: string[]): boolean => patterns.some((pattern) => minimatch(toMatch, pattern));
